import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({


  header: { // Changed to lowercase to match usage
    width: '100%', // Matches the width of the page
    position: 'absolute', // Fix the header position
    top: 0, // Align to the top of the page
    left: 0, // Align to the left
    width: '100%', // Full width of the page
    height: 96, // Fixed height that won't change
    paddingTop: 36, // Fixed padding for consistent spacing
    paddingRight: 36,
    paddingBottom: 0,
    paddingLeft: 36,
    overflow: 'hidden', // Ensures content doesn't exceed the height
    flexShrink: 0, // Prevent shrinking of the container
    flexGrow: 0, // Prevent growing of the container
  },

  section: {
    top: 80,
    marginLeft: 36,
    marginRight: 36,
    marginTop: 20,
    marginBottom: 34
  },

  section2: {
    top: 50,
    marginLeft: 36,
    marginRight: 36,
    marginTop: 20,
    marginBottom: 34
  },


  headerContainer: {
    display: 'flex', // Enable flexbox
    flexDirection: 'row', // Arrange children horizontally
    justifyContent: 'space-between', // Push children to the edges
    alignItems: 'center', // Align items vertically in the center
    width: '100%', // Ensure it spans the entire width
    height: '96px', // Maintain a consistent height
  },

  leftHeaderContainer: {
    width: '50%', // Take half the width
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 6,
  },

  companyHeaderText: {
    display: 'flex',
    alignSelf: 'stretch',
    color: '#00607F',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
  },

  leftHeadertext: {
    alignSelf: 'stretch', // Stretches the element to fill the available space
    color: '#292929',     // Fallback color from var(--Text-Primary)
    fontFamily: 'Roboto', // Font family
    fontSize: 10,         // Font size in points
    fontStyle: 'normal',  // Normal font style
    fontWeight: 400,      // Font weight (equivalent to 'normal')
    lineHeight: 1,        // Line height as a ratio (1 corresponds to 100%)
  },

  rightHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start', // Stack items from the top
    alignItems: 'flex-end', // Align items to the right edge
    width: 'auto', // Allow the container to adjust based on content
    marginLeft: 'auto', // Push the container to the right
    gap: 4, // Space between elements
  },

  headerImage: {
    width: 200,
    height: 25
  },

  rightHeadertext: {
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 1.2,
    marginTop: 4,
  },

  centeredContainer: {
    width: '100%', // Full width of the parent container
    height: 65, // Height of the container
    justifyContent: 'center', // Center content vertically
    alignItems: 'center', // Center content horizontally
    margin: 'auto', // Center relative to the parent
    borderTopWidth: 2, // Thickness of the top border
    borderTopColor: '#cccccc', // Color of the top border
    paddingTop: 10, // Space between the border and the title
  },


  bigText: {
    fontSize: 24,
    fontWeight: 700,
    color: '#292929',
    textAlign: 'center', // Center align text
    fontFamily: 'Roboto', // Font family
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold font weight
    lineHeight: 'auto', // Normal line height
  },

  bigTextDefinitions: {
    fontSize: 16,
    fontWeight: 700,
    color: '#292929',
    textAlign: 'center', // Center align text
    fontFamily: 'Roboto', // Font family
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold font weight
    lineHeight: 'auto', // Normal line height
  },

  tableFirstPage: {
    display: 'flex', // Enable flexbox
    width: 540, // Set width to 540px
    flexDirection: 'column', // Arrange children in a column
    alignItems: 'flex-start', // Align items to the start of the container

  },

  firstWhiteRow: {
    display: 'flex', // Enable flexbox
    flexDirection: 'row', // Align items horizontally
    alignItems: 'flex-start', // Align children to the start horizontally
    alignSelf: 'stretch', // Stretch the container to fill the parent
    borderBottom: '2 solid #cce0e6', // Bottom border
    borderTop: '2 solid #cce0e6', // Bottom border
    paddingTop: 2, // Add space above the top border
    paddingBottom: 3, // Add space below the bottom border
    gap: 65,
    height: 22
  },

  whiteRow: {
    display: 'flex', // Enable flexbox
    flexDirection: 'row', // Align items horizontally
    alignItems: 'flex-start', // Align children to the start horizontally
    alignSelf: 'stretch', // Stretch the container to fill the parent
    borderBottom: '2 solid #cce0e6', // Bottom border
    paddingTop: 2, // Add space above the top border
    paddingBottom: 3, // Add space below the bottom border
    gap: 65,
    height: 22
  },

  textWhiteRow: {
    paddingTop: 2,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    lineHeight: 1, // Line height as a ratio (100% = 1)
  },

  blueRow: {
    display: 'flex', // Enable flexbox
    flexDirection: 'row', // Stack items vertically
    paddingTop: 8, // Top padding
    paddingBottom: 8, // Bottom padding
    alignItems: 'flex-start', // Align items to the start horizontally
    alignSelf: 'stretch', // Stretch the container to fill the parent
    borderBottom: '1 solid #cce0e6', // Bottom border
    backgroundColor: 'rgba(0, 96, 127, 0.1)', // Background color
    gap: 65,
  },


  textBlueRow: {
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    lineHeight: 1, // Line height as a ratio (100% = 1)
  },

  textBlueRowVIN: {
    position: "absolute",
    marginTop: 7,
    left: 175,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 11, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    width: 150
  },

  textBlueRowMiles: {
    position: "absolute",
    marginTop: 7,
    left: 370,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
  },

  alignLeftContainer: {
    position: 'absolute',
    top: 238,      // Your required position
    left: 212,     // Your required position
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,        // Space between elements
  },


  textBlueRowPLCG: {
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: '400',
    marginLeft: 2, // Adjust spacing as needed
  },

  gradeContainer: {
    flexShrink: 1,  // Allows container to shrink if needed
    minWidth: 5,   // Minimum width for small values
  },

  slash: {
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 12,
    paddingHorizontal: 2,  // Space around slash
  },
  condition: {
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 12,
    flexShrink: 1,  // Prevent overflow
  },

  textBlueRowGrade: {
    marginTop: 7,
    left: 28,
    position: 'absolute',
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: '400',
    textAlign: 'right',  // Align text to right within container
    width: 200
  },

  textBlueRowMA: {
    position: "absolute",
    marginTop: 7,
    left: 369,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size
    fontStyle: 'normal', // Font style
    fontWeight: 400, // Use string for compatibility with React PDF
    whiteSpace: 'nowrap', // Prevent text wrapping
    width: 200,
    overflow: 'hidden', // Hide any overflow
  },

  notesRow: {
    width: 540,
    height: 170,
    padding: 8,
    fontFamily: 'Roboto',
    fontSize: 12,
    backgroundColor: "#e6eff2",
    overflow: 'hidden',
  },



  //THIS PART IS DEDICATED TO THE LAYOUT WHEN YEAR MAKE MODEL IS  TOO BIG

  textWhiteRowBigHeaderMA: {
    position: "absolute",
    marginTop: 5,
    left: 280,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size
    fontStyle: 'normal', // Font style
    fontWeight: 400, // Use string for compatibility with React PDF
    whiteSpace: 'nowrap', // Prevent text wrapping
    width: 200,
    overflow: 'hidden', // Hide any overflow
  },

  textWhiteRowBigHeaderOdometer: {
    position: "absolute",
    marginTop: 5,
    left: 385,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size
    fontStyle: 'normal', // Font style
    fontWeight: 400, // Use string for compatibility with React PDF
    whiteSpace: 'nowrap', // Prevent text wrapping
    width: 200,
    overflow: 'hidden', // Hide any overflow
  },

  textBlueRowBigHeaderVin: {
    position: 'absolute',
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 11, // Font size
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight
    width: 160, // Adjust width to give more space for VIN
    textAlign: 'left', // Align VIN text to the left
    marginLeft: 385, // Move VIN closer to Year Make Model
  },
  
  

  textBlueRowBigHeaderGrade: {
    marginTop: 7,
    right: 330,
    position: 'absolute',
    color: '#292929',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: '400',
    textAlign: 'left',  // Align text to right within container
    width: 120
  },

  textBlueRowBigHeaderMA: {
    position: "absolute",
    marginTop: 7,
    left: 281,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size
    fontStyle: 'normal', // Font style
    fontWeight: 400, // Use string for compatibility with React PDF
    whiteSpace: 'nowrap', // Prevent text wrapping
    width: 200,
    overflow: 'hidden', // Hide any overflow
  },

  textBlueRowBigHeaderMiles: {
    position: "absolute",
    marginTop: 7,
    left: 386,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
  },



















  textBlueRowNotes: {
    marginRight: 2,
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    lineHeight: 1, // Line height as a ratio (100% = 1)
  },


  textContainer: {
    top: 70,
    display: 'flex', // Enable flexbox
    flexDirection: 'column', // Stack items vertically
    alignItems: 'flex-start', // Align items to the left
    width: 376, // Set width to 376px
    paddingLeft: 2, // Add padding to the left
    gap: 10, // Spacing between children

    marginLeft: 0, // Ensure it aligns to the left of the page
  },

  textHeader: {
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold text
    lineHeight: 1, // Line height ratio (100% = 1)
    textDecoration: 'underline', // Add underline
  },

  topicsTextContainer: {
    top: -10, // Move up by 10px
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.4, // Line height ratio (140% = 1.4)
    alignSelf: 'stretch', // Stretch to fill the available space
  },

  actualCashValueContainer: {
    bottom: 135,
    left: 420,
    display: 'flex', // Enable flexbox
    width: 121, // Set width in points
    flexDirection: 'column', // Arrange children vertically
    alignItems: 'flex-start', // Align children to the start of the container
    border: '1 solid #cce0e6',
  },

  firstacvcontainer: {
    display: 'flex', // Enable flexbox
    flexDirection: 'column', // Arrange children in a column
    justifyContent: 'center', // Center items vertically
    alignItems: 'center', // Center items horizontally
    paddingTop: 8, // Adjust padding as needed
    paddingRight: 0,
    paddingBottom: 4,
    paddingLeft: 6,
    alignSelf: 'stretch', // Stretch the container to fill the parent
  },

  secondacvcontainer: {
    display: 'flex',          // Enable flexbox
    flexDirection: 'column',  // Arrange children in a column (optional since there's one child)
    justifyContent: 'center', // Center content vertically
    alignItems: 'center',     // Center content horizontally
    padding: 0,               // Remove padding to avoid shifting
    alignSelf: 'stretch',     // Stretch to fill the parent container
    backgroundColor: '#cce0e6', // Background color
    borderWidth: 1,           // Correct border definition
    borderColor: '#b8d3db',   // Border color
    height: 22,
    margin: 0,                // Ensure no negative margin affects layout
  },


  textAcv: {
    color: '#292929', // Text color
    textAlign: 'center', // Align text within its box
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    lineHeight: 1, // Line height as a ratio (100%)
    bottom: 2
  },

  numbertext: {
    color: '#292929',         // Text color
    textAlign: 'center',      // Horizontally center the text
    fontFamily: 'Roboto',     // Font family
    fontSize: 10,             // Font size
    fontWeight: 900,          // Bold text
    lineHeight: 1,            // Line height (adjust as needed)
  },


  valuationDataContainer: {
    bottom: 125,
    left: 420,
    display: 'flex', // Enable flexbox
    width: 121, // Set width in points
    flexDirection: 'column', // Arrange children vertically
    alignItems: 'flex-start', // Align children to the start of the container
    border: '1 solid #cce0e6',
  },

  firstvaluationcontainer: {
    display: 'flex', // Enable flexbox
    flexDirection: 'column', // Arrange children in a column
    justifyContent: 'center', // Center items vertically
    alignItems: 'center', // Center items horizontally
    paddingTop: 8, // Adjust padding as needed
    paddingRight: 0,
    paddingBottom: 4,
    paddingLeft: 6,
    alignSelf: 'stretch', // Stretch the container to fill the parent
  },

  textvaluation: {
    color: '#292929', // Text color
    textAlign: 'center', // Align text within its box
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Font weight (normal)
    lineHeight: 1, // Line height as a ratio (100%)
    bottom: 2
  },

  secondValuationContainer: {
    display: 'flex', // Enable flexbox
    flexDirection: 'column', // Arrange children in a column
    justifyContent: 'center', // Center items vertically
    alignItems: 'center', // Center items horizontally
    paddingTop: 8, // Top padding
    paddingRight: 0, // Right padding
    paddingBottom: 4, // Bottom padding
    paddingLeft: 6, // Left padding
    alignSelf: 'stretch', // Stretch the container to fill the parent
    backgroundColor: '#cce0e6', // Background color
    border: '1 solid #b8d3db', // Border
    margin: -1, // Negative margin to extend the container outward
  },

  dateText: {
    color: '#292929', // Text color
    textAlign: 'center', // Align text horizontally
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 900, // Font weight (bold)
    lineHeight: 1, // Line height as a ratio (100%)
    bottom: 2
  },

  tonyLogoContainer: {
    left: 425,
    bottom: 25,
    alignSelf: "center",
    position: "absolute",
  },

  tonyLogo: {
    width: 108,
    height: 91,
  },

  circleIcon: {
    width: 2, // Circle size
    height: 2,
    borderRadius: 4, // Makes it a circle
    backgroundColor: '#292929', // Circle color
    marginRight: 6, // Space between the circle and the text
  },

  textRow: {
    flexDirection: 'row',
    alignItems: 'center', // Align circle and text vertically
    marginBottom: 3, // Spacing between rows
  },

  certificationBusinessContainer: {
    marginTop: 30, // 30 pixels from the top content
    marginBottom: 16, // 16 pixels from the bottom component
    justifyContent: 'center', // Center vertically within its parent container
    alignItems: 'center', // Center horizontally within its parent container
    width: '100%', // Ensures it spans the full width
    borderTopWidth: 2, // Thickness of the top border
    borderTopColor: '#cccccc', // Color of the border (black in this case)
    paddingTop: 30, // Space between the border and the text
    marginBottom: 16, // 16 pixels of space between this and the next container
  },

  certificationBusinessText: {
    display: 'flex', // Default in React PDF
    width: 310, // Width in points (no "px" needed)
    height: 19, // Height in points
    flexDirection: 'column', // Layout direction
    justifyContent: 'flex-end', // Align content to the bottom
    flexShrink: 0, // Prevent shrinking
    color: '#292929', // Primary text color
    textAlign: 'center', // Center align text
    fontFamily: 'Roboto', // Font family
    fontSize: 16, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold font weight
    lineHeight: 'auto', // Normal line height
  },

  certificationContainer: {
    height: 32,
    display: 'flex', // Default in React PDF
    flexDirection: 'row',
    width: 540, // Width in points (no "px" needed)
    paddingHorizontal: 10, // Horizontal padding
    justifyContent: 'space-between', // Center content horizontally
    alignItems: 'center', // Center content vertically
    gap: 10, // Spacing between children
    borderWidth: 1, // Border thickness
    borderColor: '#CCCCCC', // Border color in HEX
    borderStyle: 'solid', // Border style
  },

  firstPartContainer: {
    flex: 1, // Optional: Allow it to grow and occupy space proportionally
  },

  vehicleSubjectText: {
    color: '#292929', // Primary text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1, // Equivalent to 100% of the font size (12px in this case)
  },

  secondPartContainer: {
    display: 'flex', // Default in React PDF
    paddingTop: 10, // Top padding
    paddingRight: 0, // Right padding
    paddingBottom: 10, // Bottom padding
    paddingLeft: 10, // Left padding
    justifyContent: 'space-between', // Space between children
    alignItems: 'center', // Center children vertically
    flexGrow: 1, // Grow the container
    flexShrink: 0, // Prevent shrinking
    flexBasis: 0, // Initial size of the container
    borderLeftWidth: 1, // Thickness of the left border
    borderLeftColor: '#CCCCCC', // Color of the left border
    borderStyle: 'solid', // Solid border style
    marginLeft: -120, // Move the container more to the left
    height: 32, // Increase the height of the left border
  },

  codeText: {
    flexGrow: 1, // Equivalent to `flex: 1`
    flexShrink: 0, // Equivalent to `flex: 0`
    flexBasis: 0, // Equivalent to `flex-basis: 0`
    color: '#292929', // Primary text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold font weight
    lineHeight: 1, // Equivalent to 100% of font size
    marginLeft: -240, // Move the text 10 points to the left
    textAlign: 'left', // Ensure the text is aligned to the left
  },

  vinSpecialContainer: {
    left: 200,
    position: 'absolute',
    display: 'flex',              // Use Flexbox for layout
    flexDirection: 'row',         // Horizontal alignment
    paddingTop: 10,               // Top padding
    paddingBottom: 10,            // Bottom padding
    paddingLeft: 10,              // Increase padding to push the content to the right
    paddingRight: 0,              // No padding on the right
    alignItems: 'center',         // Vertically center the content
    justifyContent: 'flex-start', // Align content to the left
    borderLeftWidth: 1,           // Thickness of the left border
    borderLeftColor: '#CCCCCC',   // Light gray border color
    borderStyle: 'solid',         // Solid border style
    height: 32,                   // Fixed height for consistent layout
    marginRight: 275,
    width: 150               
  },

  vinSpecial: {
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size
    fontWeight: 700, // Bold font weight
    lineHeight: 1, // Line height for compact text
    marginLeft: 0, // Remove extra margin to align with the border
    textAlign: 'left', // Align text to the left
  },




  textPersuantContainer: {
    top: 16,
    width: 540, // Width in points
    color: '#292929', // Primary text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 2.4, // Line height (240% is equivalent to 2.4 times the font size)
  },

  swornContainer: {
    top: 41,
    display: 'flex', // Default in React PDF
    width: 174, // Width in points
    flexDirection: 'column', // Arrange children in a column
    alignItems: 'flex-start', // Align children to the start of the container
    gap: 6, // Spacing of 6 points between children
    borderBottomWidth: 1, // Thickness of the bottom border
    borderBottomColor: '#292929', // Border color in HEX (black in this case)
    borderStyle: 'solid', // Style of the border
    paddingBottom: 2, // Space between the title and the border
    marginBottom: 20, // Space between this container and subsequent content
  },

  swornText: {
    alignSelf: 'stretch', // Stretches the element to fill its parent's width
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.4, // Line height (140% of font size)
  },

  swornDate: {
    width: 174, // Width in points
    color: '#292929', // Text color in HEX
    textAlign: 'right', // Align text to the right
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1, // Line height (100% of font size, equivalent to 10px)
  },

  signImage: {
    width: 101, // Width in points
    height: 74, // Height in points
    position: 'absolute', // Absolute positioning
    left: 380, // 12 points from the left of the parent container
    top: 375, // 57 points above the top of the parent container
  },

  signatureText: {
    top: 7,
    left: 360,
    width: 174, // Width in points
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1, // Line height (100% of font size, equivalent to 10 points)
    borderTopWidth: 1, // Thickness of the bottom border
    borderTopColor: '#292929', // Border color in HEX (black in this case)
    borderStyle: 'solid', // Style of the border
    paddingTop: 2, // Space between the title and the border
  },

  tonyContainer: {
    display: 'flex', // Default in React PDF
    flexDirection: 'column', // Arrange children vertically
    alignItems: 'flex-start', // Align children to the start of the container
    gap: 3, // Space of 3 points between children
    left: 360,
    bottom: 15
  },

  tonyText: {
    width: 174, // Width in points
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 12, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.5, // Line height (150% of font size, equivalent to 18 points)
    borderBottomWidth: 1, // Thickness of the bottom border
    borderBottomColor: '#292929', // Color of the bottom border
    borderStyle: 'solid', // Border style (solid, dashed, dotted)
  },

  signatureRecordsText: {
    width: 174, // Width in points
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1, // Line height (100% of font size, equivalent to 10 points)
  },

  publicSignatureContainer: {
    top: 60,
    display: 'flex', // Default in React PDF
    width: 321, // Width in points
    flexDirection: 'row', // Arrange items horizontally
    justifyContent: 'space-between', // Spread out children horizontally
    alignItems: 'center', // Align children vertically in the center
  },

  textPublicSignature: {
    width: 175, // Width in points
    flexShrink: 0, // Prevent the element from shrinking
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.4, // Line height (140% of font size, equivalent to 14 points)
    marginRight: 20, // Adds space between the text and the image
  },

  textPublicSignatureWithLine: {
    width: 175, // Width in points
    flexShrink: 0, // Prevent the element from shrinking
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 10, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.4, // Line height (140% of font size, equivalent to 14 points)
    marginRight: 20, // Adds space between the text and the image
    borderBottomWidth: 1, // Thickness of the bottom line
    borderBottomColor: '#292929', // Color of the bottom line
    borderStyle: 'solid', // Style of the bottom line
  },

  publicSignatureImg: {
    bottom: 3,
    left: 190,
    position: "absolute",
    width: 100, // Width in points
    height: 23, // Height in points
  },

  imgLine: {
    position: "absolute",
    width: 153, // Full width or adjust as needed
    height: 1, // Thickness of the line,
    backgroundColor: '#292929', // Line color
    position: 'relative', // Adjust if necessary
    marginTop: 10, // Optional: Space above the line
    marginBottom: 10, // Optional: Space below the line
  },

  officialSealContainer: {
    top: 515,
    left: 360,
    position: "absolute",
    width: 175,
    height: 67
  },

  noteContainer: {
    top: 120,
    width: 540, // Width in points
    color: '#292929', // Text color in HEX
    fontFamily: 'Roboto', // Font family
    fontSize: 9, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 400, // Normal font weight
    lineHeight: 1.4, // Line height (140% of font size, equivalent to 12.6 points)
  },

  vehicleTextContainer: {
    justifyContent: 'center', // Center vertically within its parent container
    alignItems: 'center', // Center horizontally within its parent container
    width: '100%', // Ensures it spans the full width
    borderTopWidth: 2, // Thickness of the top border
    borderTopColor: '#cccccc', // Color of the border (black in this case)
    paddingTop: 30, // Space between the border and the text
    marginBottom: 10, // 16 pixels of space between this and the next container
  },

  vehicleText: {
    display: 'flex', // Default in React PDF
    width: 310, // Width in points (no "px" needed)
    height: 19, // Height in points
    flexDirection: 'column', // Layout direction
    justifyContent: 'flex-end', // Align content to the bottom
    flexShrink: 0, // Prevent shrinking
    color: '#292929', // Primary text color
    textAlign: 'center', // Center align text
    fontFamily: 'Roboto', // Font family
    fontSize: 16, // Font size in points
    fontStyle: 'normal', // Normal font style
    fontWeight: 700, // Bold font weight
    lineHeight: 'auto', // Normal line height
  },

  carImgContainer: {
    width: 540,
    height: 368
  },

  conditionTable: {
    display: 'flex',
    width: 540,              // Set width of the table
    flexDirection: 'column', // Arrange content vertically
    alignItems: 'flex-start', // Align content to the left
    marginLeft: 'auto',       // Centers the table horizontally
    marginRight: 'auto',      // Centers the table horizontally
    marginTop: 'auto',        // Centers the table vertically
    marginBottom: 'auto',     // Centers the table vertically
  },

  imageGrid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap', // Allow wrapping
    justifyContent: 'center', // Center rows horizontally
    alignItems: 'flex-start', // Align items at the top
    width: 540, // Constrain to the appropriate width
    height: 'auto', // Dynamically adjust based on content
    gap: 10, // Add consistent spacing
  },

  gridImage: {
    height: 183,
    width: 250, // Ensure this is smaller than the grid width to allow wrapping

  },

  firstRowContainer: {
    height: 32,
    display: 'flex',               // Flexbox layout
    flexDirection: 'row',          // Children will be placed horizontally
    padding: '0px 10px',           // Padding on left and right
    justifyContent: 'space-between', // Distribute children with space between
    alignItems: 'center',          // Vertically align children in the center
    alignSelf: 'stretch',          // Stretch this container to the full width
    borderWidth: 1,                // Border thickness
    borderColor: '#A3C6D1',        // Border color
    backgroundColor: 'rgba(0, 96, 127, 0.20)', // Background with transparency
  },

  otherRow: {
    display: 'flex',               // Flexbox layout
    flexDirection: 'row',          // Children will be placed horizontally
    alignItems: 'center',          // Vertically align children in the center
    alignSelf: 'stretch',          // Stretch this container to the full width
    borderWidth: 1,                // Border thickness
    borderColor: '#c5d8de',        // Border color
  },

  textCondition: {
    color: '#292929',           // Text color (#292929)
    fontFamily: 'Roboto',       // Font family (Roboto)
    fontSize: 12,               // Font size (12px)
    fontStyle: 'normal',        // Font style (normal)
    fontWeight: '400',          // Font weight (normal)
  },

  descriptionTextContainer: {
    margin: 0,
    padding: 0,
  },

  lineFirst: {
    left: 36,
    top: 165,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  lineSecond: {
    left: 36,
    top: 211,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  lineThird: {
    left: 36,
    top: 256,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },



  line: {
    top: 31,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line2: {
    top: 81,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },


  line3: {
    top: 131,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line4: {
    top: 181,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line5: {
    top: 231,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line6: {
    top: 281,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line7: {
    top: 331,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line8: {
    top: 381,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line9: {
    top: 431,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line10: {
    top: 481,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },

  line11: {
    top: 531,
    position: 'absolute', // Absolute positioning
    height: 2,            // Height of the line
    backgroundColor: '#c5d8de', // Line color
    width: 540,        // Default to full width (customizable later)             // Start at the left edge
  },


  descriptionText: {
    paddingLeft: 10,
    color: '#292929',           // Text color (#292929)
    fontFamily: 'Roboto',       // Font family (Roboto)
    fontSize: 12,               // Font size (12px)
    fontStyle: 'normal',        // Font style (normal)
    fontWeight: '400',          // Font weight (normal)
  },

  descriptionTextHeader: {
    paddingLeft: 10,
    color: '#292929',           // Text color (#292929)
    fontFamily: 'Roboto',       // Font family (Roboto)
    fontSize: 12,               // Font size (12px)
    fontStyle: 'normal',        // Font style (normal)
    fontWeight: '400',
  },

  otherConditionTextContainer: {
    position: 'relative', // Ensures positioning remains within layout flow
    left: 10,
    top: 10,
    width: 121,
    height: 48,
  },


  tableHeaderText: {
    color: '#292929',               // Text color
    fontFamily: 'Roboto',           // Font family
    fontSize: 12,                   // Font size
    fontStyle: 'normal',            // Font style
    fontWeight: '700',              // Font weight (bold)
  },


  verticalLine: {
    position: 'absolute',
    width: 1,                 // Thickness of the line (1px or more if needed)
    height: 582,           // Full height (or set a specific height)
    backgroundColor: '#a3c6d1', // Line color (change to whatever color you want)
    left: 150,
    top: 165
  },

  footer: {
    bottom: 20,
    left: '46%',
    color: '#292929', // Text color
    fontFamily: 'Roboto', // Font family
    fontSize: 7.3, // Font size in pt (React PDF uses numbers for sizes)
    fontStyle: 'normal', // Font style
    fontWeight: '700', // Font weight
    lineHeight: 1, // Line height (React PDF accepts a unitless value for line height)
    position: 'absolute'
  },

  noImageText: {
    color: '#555555', // Subtle dark gray for readability
    fontFamily: 'Roboto', // Clean and modern font
    fontSize: 16, // Slightly larger font for visibility
    fontWeight: '500', // Medium weight for emphasis
    textAlign: 'center', // Center text horizontally
    marginTop: 20, // Add space above the text
    marginBottom: 20, // Add space below the text
    padding: 10, // Add internal padding for balance
  },




});

export default styles;
